import React, { useEffect, useState } from 'react';

const CareersAdmin = () => {
    const [careers, setCareers] = useState([]);
    const [newJob, setNewJob] = useState({ title: '', description: '' });

    useEffect(() => {
        fetch('http://localhost:5000/api/careers')
            .then(res => res.json())
            .then(data => setCareers(data));
    }, []);

    const addJob = () => {
        fetch('http://localhost:5000/api/careers', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(newJob),
        })
            .then(res => res.json())
            .then(data => setCareers([...careers, data]));
        setNewJob({ title: '', description: '' });
    };

    const deleteJob = (id) => {
        fetch(`http://localhost:5000/api/careers/${id}`, { method: 'DELETE' })
            .then(() => setCareers(careers.filter(job => job.id !== id)));
    };

    return (
        <div>
            <h2>Manage Careers</h2>
            <input
                type="text"
                value={newJob.title}
                onChange={(e) => setNewJob({ ...newJob, title: e.target.value })}
                placeholder="Job Title"
            />
            <textarea
                value={newJob.description}
                onChange={(e) => setNewJob({ ...newJob, description: e.target.value })}
                placeholder="Job Description"
            />
            <button onClick={addJob}>Add Job</button>
            <ul>
                {careers.map((job) => (
                    <li key={job.id}>
                        <h3>{job.title}</h3>
                        <p>{job.description}</p>
                        <button onClick={() => deleteJob(job.id)}>Delete</button>
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default CareersAdmin;
